import './style.css';

// Airtable Configuration
const AIRTABLE_CONFIG = {
  baseId: 'appyZn79Ksa3gXTWR',
  tableId: 'tblvKLQqwIq35ekB6',
  token: 'patqiDvDN60dNQSmQ.f0ba866fa083d6f2d61b36a8587810b12fa685e1a3b8763cd11260e56f11ae30'
};

// DOM Elements
const hamburger = document.getElementById('hamburger');
const navMenu = document.getElementById('nav-menu');
const loginBtn = document.getElementById('login-btn');
const loginModal = document.getElementById('login-modal');
const registerModal = document.getElementById('register-modal');
const closeModal = document.getElementById('close-modal');
const closeRegisterModal = document.getElementById('close-register-modal');
const loginForm = document.getElementById('login-form');
const registerForm = document.getElementById('register-form');
const registerLink = document.getElementById('register-link');
const loginLink = document.getElementById('login-link');

// Mobile Menu Toggle
hamburger.addEventListener('click', () => {
  navMenu.classList.toggle('active');
  
  // Animate hamburger
  hamburger.classList.toggle('active');
});

// Close mobile menu when clicking on links
document.querySelectorAll('.nav-link').forEach(link => {
  link.addEventListener('click', () => {
    navMenu.classList.remove('active');
    hamburger.classList.remove('active');
  });
});

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// Modal Functions
function openModal(modal) {
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeModalFunc(modal) {
  modal.style.display = 'none';
  document.body.style.overflow = 'auto';
}

// Event Listeners for Modals
loginBtn.addEventListener('click', () => openModal(loginModal));
closeModal.addEventListener('click', () => closeModalFunc(loginModal));
closeRegisterModal.addEventListener('click', () => closeModalFunc(registerModal));

registerLink.addEventListener('click', (e) => {
  e.preventDefault();
  closeModalFunc(loginModal);
  openModal(registerModal);
});

loginLink.addEventListener('click', (e) => {
  e.preventDefault();
  closeModalFunc(registerModal);
  openModal(loginModal);
});

// Close modals when clicking outside
window.addEventListener('click', (e) => {
  if (e.target === loginModal) {
    closeModalFunc(loginModal);
  }
  if (e.target === registerModal) {
    closeModalFunc(registerModal);
  }
});

// CTA Button Event Listeners
document.getElementById('get-started-btn').addEventListener('click', () => {
  openModal(registerModal);
});

document.getElementById('learn-more-btn').addEventListener('click', () => {
  document.getElementById('features').scrollIntoView({ behavior: 'smooth' });
});

document.getElementById('contact-demo-btn').addEventListener('click', () => {
  openModal(registerModal);
});

document.getElementById('contact-info-btn').addEventListener('click', () => {
  openModal(registerModal);
});

// Login Form Handler
loginForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  
  const username = document.getElementById('username').value;
  const password = document.getElementById('password').value;
  
  // Simple login validation (temporary)
  if (username === 'mvg' && password === 'mvg') {
    // Success - redirect to editor app
    alert('Login successful! Redirecting to editor...');
    window.location.href = '/app/';
  } else {
    // Check if user exists in Airtable
    try {
      const isValidUser = await checkUserCredentials(username, password);
      if (isValidUser) {
        alert('Login successful! Redirecting to editor...');
        window.location.href = '/app/';
      } else {
        alert('Invalid username or password. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Login failed. Please try again.');
    }
  }
});

// Registration Form Handler
registerForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  
  const customerName = document.getElementById('reg-name').value;
  const email = document.getElementById('reg-email').value;
  const phoneNumber = document.getElementById('reg-phone').value;
  
  try {
    const success = await registerUser({
      customerName,
      email,
      phoneNumber
    });
    
    if (success) {
      alert('Account created successfully! You can now login.');
      closeModalFunc(registerModal);
      openModal(loginModal);
      registerForm.reset();
    } else {
      alert('Registration failed. Please try again.');
    }
  } catch (error) {
    console.error('Registration error:', error);
    alert('Registration failed. Please check your information and try again.');
  }
});

// Airtable Functions
async function registerUser(userData) {
  const url = `https://api.airtable.com/v0/${AIRTABLE_CONFIG.baseId}/${AIRTABLE_CONFIG.tableId}`;
  
  const payload = {
    records: [
      {
        fields: {
          'Customer Name': userData.customerName,
          'Email': userData.email,
          'Phone Number': userData.phoneNumber,
          'Registration Date': new Date().toISOString().split('T')[0],
          'Status': 'Active',
          'Registered via Safepath Website': true
        }
      }
    ]
  };
  
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${AIRTABLE_CONFIG.token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    if (response.ok) {
      const result = await response.json();
      console.log('User registered successfully:', result);
      return true;
    } else {
      console.error('Registration failed:', response.status, response.statusText);
      return false;
    }
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
}

async function checkUserCredentials(email, password) {
  // For now, we'll just check if the email exists in Airtable
  // In a real application, you would have proper password hashing and verification
  const url = `https://api.airtable.com/v0/${AIRTABLE_CONFIG.baseId}/${AIRTABLE_CONFIG.tableId}?filterByFormula={Email}="${email}"`;
  
  try {
    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${AIRTABLE_CONFIG.token}`
      }
    });
    
    if (response.ok) {
      const result = await response.json();
      return result.records && result.records.length > 0;
    } else {
      console.error('User check failed:', response.status, response.statusText);
      return false;
    }
  } catch (error) {
    console.error('User check error:', error);
    throw error;
  }
}

// Navbar scroll effect
window.addEventListener('scroll', () => {
  const navbar = document.getElementById('navbar');
  if (window.scrollY > 50) {
    navbar.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
    navbar.style.backdropFilter = 'blur(10px)';
  } else {
    navbar.style.backgroundColor = 'var(--white)';
    navbar.style.backdropFilter = 'none';
  }
});

// Intersection Observer for animations
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, observerOptions);

// Observe elements for scroll animations
document.addEventListener('DOMContentLoaded', () => {
  const animatedElements = document.querySelectorAll('.feature-card, .process-step, .use-case-card');
  
  animatedElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});

// Loading state management
document.addEventListener('DOMContentLoaded', () => {
  // Hide loading spinner if any
  const loader = document.querySelector('.loader');
  if (loader) {
    loader.style.display = 'none';
  }
  
  // Initialize any other components
  console.log('Safepath website loaded successfully');
});